import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useTemplatePreview = () => {
    const additional = useQueryRequestParams();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('templates/preview/'), body, additional)
    });
};
export default useTemplatePreview;
